import React from "react";

export default class AdminErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error?.message || "Unknown UI error" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Admin UI crashed", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, errorMessage: "" });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="mx-auto mt-8 max-w-3xl rounded-xl border border-rose-300/30 bg-rose-500/10 p-6 text-slate-100">
          <h2 className="font-display text-xl">Admin UI error</h2>
          <p className="mt-2 text-sm text-slate-300">{this.state.errorMessage}</p>
          <button
            type="button"
            onClick={this.handleRetry}
            className="mt-4 rounded-md border border-white/20 bg-white/5 px-4 py-2 text-sm text-white hover:bg-white/10"
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
